import Lenis from 'lenis';

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ autoRaf: true, duration: 1.15, smoothWheel: true });
  return lenis;
}

export function scrollToId(id) {
  if (lenis) {
    lenis.scrollTo(id, { offset: -12, duration: 1.5, easing: (t) => 1 - Math.pow(1 - t, 4) });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });
  }
}
